'use client';

import React, { Dispatch, SetStateAction, createContext, useState } from 'react';
import Toast from '../../basic/Toast';

type NotificationType = React.ComponentProps<typeof Toast>['type'];

interface INotificationContext {
  open: boolean;
  setOpen: Dispatch<SetStateAction<boolean>>;
  type: NotificationType;
  setType: Dispatch<SetStateAction<NotificationType>>;
  message: string;
  setMessage: Dispatch<SetStateAction<string>>;
}

export const NotificationContext = createContext<INotificationContext>({} as INotificationContext);

export default function NotificationProvider({ children }: React.PropsWithChildren) {
  const [open, setOpen] = useState(false);
  const [type, setType] = useState<NotificationType>();
  const [message, setMessage] = useState('');

  return (
    <NotificationContext.Provider value={{ open, setOpen, type, setType, message, setMessage }}>
      {children}
      <Toast
        title={message}
        type={type}
        rootProps={{
          open,
          onOpenChange: setOpen,
          duration: 5000,
        }}
      />
    </NotificationContext.Provider>
  );
}
